import { proxy } from 'valtio';
/**
 * # 計畫以 {@link staticStore} 替代
 *
 * @deprecated
 */
export const staticrcStore = proxy({
    contractInfo: {},
});
